(function ($) {
    $.YPTC = $.YPTC || {};
    $.YPTC.Delta = $.YPTC.Delta || {};
    $.YPTC.Delta.SideNav = $.YPTC.Delta.SideNav || (function () {
        const
        init = function () {
            let e = document.getElementById('menuControl');
            if (e !== null) e.addEventListener('click', onClick, false);
        },
        toggle = function(ctrl, isOpen, useTransition) {
            ctrl.setAttribute('aria-expanded', `${isOpen.toString()}`);
            ctrl.setAttribute('title', `${isOpen ? 'Collapse Menu' : 'Expand Menu'}`);
            document.getElementById('sidenav').classList.toggle('show');
            cookieStore.set({ name: 'SideNavState', value: isOpen.toString() });
        },
        onClick = function(evt){
            evt.preventDefault();
            let ctrl = document.getElementById('menuControl');
            let isOpen = ctrl.getAttribute('aria-expanded') !== 'true';
            toggle(ctrl, isOpen);
        }

        document.addEventListener('DOMContentLoaded', init);
    })();
})(jQuery);